<template>
  <b-card>
    <div class="d-flex justify-content-between gap-2 mb-3">
      <h1>Admins</h1>
      <router-link to="/admins/create">
        <b-button variant="primary" v-if="currentUser.role === 'SuperAdmin'"
          >Add Admin</b-button
        >
      </router-link>
    </div>
    <Table :fields="fields" :data="data">
      <template #actions="row">
        <div class="d-flex gap-2" v-if="currentUser.role === 'SuperAdmin'">
          <router-link
            :to="{ name: 'edit-admins', params: { id: row.item.id } }"
          >
            <b-button size="sm" variant="warning">Edit</b-button>
          </router-link>
          <b-button size="sm" variant="danger" @click="deleteAdmin(row.item.id)"
            >Delete</b-button
          >
        </div>
      </template>
    </Table>
  </b-card>
</template>

<script>
import Table from "@/components/Table.vue";
import AdminService from "../../../core/services/admin.service";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";

export default {
  computed: {
    ...mapGetters(["currentUser"]),
  },
  components: { Table },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email", thStyle: { width: "20%" } },
        { key: "role", label: "Role" },
        { key: "actions", label: "Actions" },
      ],
      data: [],
    };
  },
  methods: {
    async fetchAdmins() {
      const { data } = await AdminService.fetchAdmins();
      this.data = data.admins;
    },
    async deleteAdmin(id) {
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure to delete this admin?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2196f3",
        cancelButtonColor: "#F64E60",
        confirmButtonText: "Yes, delete it!",
      });

      if (!isConfirmed) return;

      try {
        await AdminService.deleteAdmin(id);
        this.fetchAdmins();
      } catch (error) {
        const errorMessage = error.response
          ? error.response.data.message
          : error.message;
        this.$toasted.error(errorMessage);
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Admins", route: "/admins" },
    ]);
    this.fetchAdmins();
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 100%;
}
.gap-2 {
  gap: 0.5rem;
}
</style>
